import { Tooltip } from "@ficatranquilo/contabilidade.com-ui";
import { DomainStatus } from "@components/ow";

const WAITING_HINT = "Importado por planilha. O colaborador ainda não acessou esta empresa.";

/** Situação do vínculo com a empresa: lista e detalhe do colaborador e permissões. */
export default function LinkStatus({ status }) {
  if (status !== "WAITING") return <DomainStatus domain="prestador" value="ativo" />;
  return (
    <Tooltip content={WAITING_HINT} $position="top" $size="medium" $color="dark">
      <span>
        <DomainStatus domain="prestador" value="primeiro_acesso" />
      </span>
    </Tooltip>
  );
}
